import { useState } from 'react'

import { useNewPatients } from './useNewPatients'

export function useToggleSound(waitingRoomId: string) {
  // Sound mute state with localStorage persistence. NOTE: compare against the literal 'true' —
  // `Boolean('false')` is `true`, so the previous `Boolean(stored)` read inverted a stored "false".
  const [isMuted, setIsMuted] = useState(() => localStorage.getItem('waitingRoomSoundMuted') === 'true')

  // Play a ping when patients actually arrive (the effect used to be keyed on [isMuted] only, so it
  // fired once on mount and never on arrival).
  useNewPatients(waitingRoomId, () => {
    if (isMuted) return
    try {
      const audioPlayResult = new Audio('/sound/ping.wav').play()
      // Only call catch if play() returns a Promise.
      if (audioPlayResult && typeof audioPlayResult.catch === 'function') {
        audioPlayResult.catch(() => {
          // Ignore audio play errors (e.g., autoplay blocked until the user interacts with the page).
        })
      }
    } catch (error) {
      // Ignore audio play errors in environments where play() is synchronous.
    }
  })

  const toggleMute = () => {
    setIsMuted((prevIsMuted) => {
      const newIsMuted = !prevIsMuted
      localStorage.setItem('waitingRoomSoundMuted', `${newIsMuted}`)
      return newIsMuted
    })
  }

  return { isMuted, toggleMute }
}
